export const CONTACT = {
  brand: "Belong Saloon & Spa",
  brandFull: "Belong Saloon and Spa",
  phoneDisplay: "098666 34473",
  phoneTel: "tel:09866634473",
  address:
    "1st Floor, Plot no - 121, Road - 3, Quthbullapur Main Rd, opp. Barath Petrol pump, Suchitra, Sri Krishna Nagar, Quthbullapur, Hyderabad, Telangana 500055",
  landmark: "Opp. Barath Petrol Pump, Suchitra",
  hours: "Open Daily: 10:00 AM – 9:00 PM",
  mapEmbed:
    "https://www.google.com/maps?q=Quthbullapur%20Main%20Rd%2C%20Suchitra%2C%20Hyderabad%2C%20Telangana%20500055&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Belong+Saloon+and+Spa+Suchitra+Quthbullapur+Hyderabad",
};

export const waLink = (service) => {
  const msg = service
    ? `Hello Belong Spa, I would like to book a ${service} session.`
    : "Hello Belong Spa, I would like to book a massage appointment.";
  return `https://wa.me/919866634473?text=${encodeURIComponent(msg)}`;
};

const STD_DURATIONS = [{ mins: 45 }, { mins: 60 }, { mins: 90 }, { mins: 120 }];
const SPECIAL_DURATIONS = [{ mins: 60 }, { mins: 90 }, { mins: 120 }];

export const SERVICES = [
  {
    slug: "aroma-therapy",
    name: "Aroma Therapy Massage",
    short: "Aroma Therapy",
    tagline: "Botanical oils, breath and slow rhythmic strokes",
    description:
      "A sensory experience where warm, cold-pressed essential oils meet long, flowing strokes. Each blend is chosen for your state of mind — lavender to unwind, eucalyptus to clear, neroli to uplift — easing the nervous system into deep rest.",
    detail:
      "Your therapist begins with a short consultation to select an oil blend matched to how you feel that day. The room is kept warm and dim; the pace is unhurried. Expect feather-light to medium pressure, guided breathing, and a finish that leaves skin nourished and the mind noticeably quieter.",
    image:
      "https://images.pexels.com/photos/6724505/pexels-photo-6724505.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Aroma therapy massage with essential oils at Belong Spa Hyderabad",
    durations: STD_DURATIONS,
    whoFor: ["Stressed minds that can't switch off", "Light-to-medium pressure lovers", "Anyone struggling with sleep", "First-time spa guests"],
    benefits: ["Calms the nervous system", "Eases stress & anxiety", "Nourishes skin with botanical oils", "Improves sleep quality"],
    expect: ["Personal oil-blend consultation", "Slow, flowing full-body strokes", "Warm towels & dim candlelit suite", "Post-session herbal tea"],
  },
  {
    slug: "balinese-massage",
    name: "Balinese Massage",
    short: "Balinese",
    tagline: "Island-born palm pressure and gentle skin rolling",
    description:
      "A traditional Indonesian therapy combining palm pressure, skin rolling and acupressure along the body's energy pathways. Deeply grounding, it releases stored tension while restoring a feeling of easy, open movement.",
    detail:
      "Rooted in the healing traditions of Bali, this therapy alternates firm palm work with gentle stretches and kneading. Fragrant coconut-based oil carries the strokes, and the rhythm gradually slows your breathing. Ideal after long travel or weeks of accumulated fatigue.",
    image:
      "https://images.pexels.com/photos/37719540/pexels-photo-37719540.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Traditional Balinese massage therapy at Belong Spa Suchitra",
    durations: STD_DURATIONS,
    whoFor: ["Travellers & jet-lagged bodies", "Anyone carrying weeks of fatigue", "Fans of medium, flowing pressure", "Those seeking grounding calm"],
    benefits: ["Releases deep-seated tension", "Stimulates blood circulation", "Balances body energy", "Relieves travel & work fatigue"],
    expect: ["Warm coconut-based oils", "Palm pressure & skin rolling", "Acupressure on energy lines", "Gentle assisted stretches"],
  },
  {
    slug: "deep-tissue",
    name: "Deep Tissue Massage",
    short: "Deep Tissue",
    tagline: "Focused pressure for chronic knots and stiffness",
    description:
      "Slow, deliberate strokes and firm finger pressure reach the deeper layers of muscle and fascia. Built for desk-bound shoulders, gym-tight legs and long-standing knots that lighter massages never touch.",
    detail:
      "Your therapist maps the areas holding the most tension — usually neck, shoulders, lower back — and works them with forearms, elbows and knuckles at a pressure you set. Some tenderness is normal; relief over the following 24–48 hours is the signature of a good session.",
    image:
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxkZWVwJTIwdGlzc3VlJTIwbWFzc2FnZSUyMGJhY2slMjBmaXJtJTIwcHJlc3N1cmV8ZW58MHx8fHwxNzkyMjMyMzk1fDA&ixlib=rb-4.1.0&q=85",
    alt: "Deep tissue massage for muscle relief at Belong Spa",
    durations: STD_DURATIONS,
    whoFor: ["Desk workers with stiff necks & backs", "Gym-goers & athletes in recovery", "Chronic knot & tension carriers", "Those who prefer firm pressure"],
    benefits: ["Breaks down chronic muscle knots", "Improves posture & mobility", "Speeds sports recovery", "Relieves lower-back pain"],
    expect: ["Tension-mapping consultation", "Firm, slow deep-layer strokes", "Pressure adjusted to your comfort", "Targeted work on problem zones"],
  },
  {
    slug: "thai-massage",
    name: "Thai Massage",
    short: "Thai",
    tagline: "Rhythmic stretching along the body's energy lines",
    description:
      "An ancient, oil-free therapy performed in comfortable attire. Your therapist guides you through rhythmic compressions and assisted yoga-like stretches that open the joints and leave the whole body feeling longer and lighter.",
    detail:
      "Sometimes called 'lazy man's yoga', Thai massage works the sen energy lines with thumbs, palms and feet, interleaved with gentle rocking and deep stretches. You stay fully clothed in loose wear we provide. Expect to walk out standing taller.",
    image:
      "https://images.pexels.com/photos/14254022/pexels-photo-14254022.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Traditional Thai stretching massage at Belong Spa Hyderabad",
    durations: STD_DURATIONS,
    whoFor: ["Stiff bodies that need stretching", "Those who prefer no oils", "Yoga & flexibility enthusiasts", "Anyone feeling low on energy"],
    benefits: ["Improves flexibility & range of motion", "Energises without oil", "Opens hips, back & shoulders", "Relieves joint stiffness"],
    expect: ["Loose traditional attire provided", "Assisted yoga-like stretches", "Rhythmic palm & thumb pressure", "No oils — fully clothed session"],
  },
  {
    slug: "four-hand-massage",
    name: "Four Hand Massage",
    short: "Four Hand",
    tagline: "Two therapists moving as one choreographed rhythm",
    description:
      "Our signature indulgence: two therapists work in perfect synchrony, mirroring each stroke across both sides of the body. The mind quickly stops tracking the choreography and surrenders to a depth of relaxation a single pair of hands cannot reach.",
    detail:
      "Synchronised four-hand work doubles the sensory input, which is precisely why the brain lets go — it cannot follow both therapists at once. Sessions begin at 60 minutes to allow the full choreography to unfold across the whole body.",
    image:
      "https://images.pexels.com/photos/5888096/pexels-photo-5888096.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Four hand synchronized massage by two therapists at Belong Spa",
    durations: SPECIAL_DURATIONS,
    special: true,
    whoFor: ["Overthinkers who can't switch off", "Celebrations & special occasions", "Experienced spa guests", "Anyone wanting our deepest indulgence"],
    benefits: ["Deepest possible relaxation", "Two therapists in synchrony", "Melts mental overthinking", "A signature luxury experience"],
    expect: ["Two synchronised therapists", "Mirrored stroke choreography", "Warm oil throughout", "60-minute minimum session"],
  },
  {
    slug: "body-massage",
    name: "Full Body Massage",
    short: "Body Massage",
    tagline: "Head-to-toe renewal in one unbroken flow",
    description:
      "The classic Belong service: scalp to soles, every major muscle group eased in one continuous, unhurried sequence. Warm oil, steady pressure and a quiet room — the simplest and most complete way to reset a tired body.",
    detail:
      "This is the session most guests begin with. Your therapist works through scalp, neck, back, arms, legs and feet, checking in on pressure as they go. Choose a longer duration if you want slower, more thorough work on the back and legs.",
    image:
      "https://images.pexels.com/photos/9268042/pexels-photo-9268042.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Full body relaxation massage at Belong Spa Suchitra Hyderabad",
    durations: STD_DURATIONS,
    whoFor: ["First-time spa guests", "Full-body fatigue & aches", "Weekly wellness routines", "Anyone needing a complete reset"],
    benefits: ["Complete head-to-toe renewal", "Boosts blood circulation", "Relieves general body ache", "Perfect first-time service"],
    expect: ["Scalp-to-soles coverage", "Warm premium body oil", "Pressure tailored to you", "Quiet private suite"],
  },
  {
    slug: "jacuzzi-spa",
    name: "Jacuzzi Spa",
    short: "Jacuzzi Spa",
    tagline: "Herbal hydrotherapy beneath massaging jets",
    description:
      "Sink into a private, temperature-perfect jacuzzi as hydro-jets knead tired muscles and a herbal infusion softens the water — and the week. Add it before any massage to warm the muscles and deepen every stroke that follows.",
    detail:
      "Your private suite holds a sanitised jacuzzi drawn fresh for every guest, infused with mineral salts and botanicals. Hydro-jets target the back, legs and feet. Sessions start at 60 minutes; most guests pair the soak with a massage for a complete evening.",
    image:
      "https://images.pexels.com/photos/3851237/pexels-photo-3851237.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Luxury jacuzzi hydrotherapy spa bath at Belong Spa",
    durations: SPECIAL_DURATIONS,
    special: true,
    whoFor: ["Muscle soreness after workouts", "Couples & shared evenings", "A warm-up before any massage", "Anyone who loves warm-water therapy"],
    benefits: ["Hydro-jet muscle relief", "Private sanitised tub per guest", "Herbal mineral infusion", "Perfect pre-massage warm-up"],
    expect: ["Private jacuzzi suite", "Fresh-drawn herbal soak", "Targeted hydro-jet massage", "60-minute minimum session"],
  },
];

export const HERO_IMAGE = "/images/belong-reception.jpg";
export const HERO_SECONDARY =
  "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtYXNzYWdlJTIwb2lsJTIwcG91cmluZyUyMHRoZXJhcGlzdCUyMGhhbmRzJTIwc3BvdGxpZ2h0fGVufDB8fHx8MTc5MjIyOTM0OHww&ixlib=rb-4.1.0&q=85";
export const ABOUT_INTERIOR = "/images/belong-reception.jpg";
export const ABOUT_INTERIOR_2 =
  "https://images.pexels.com/photos/1926811/pexels-photo-1926811.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const MEMBERSHIP_IMAGE =
  "https://images.unsplash.com/photo-1630587342832-2d7d49860436?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBnb2xkJTIwc3BhJTIwYW1iaWVuY2UlMjByZXNvcnQlMjBWSVAlMjBtZW1iZXJzaGlwfGVufDB8fHx8MTc5MjIyOTM0OHww&ixlib=rb-4.1.0&q=85";
export const JACUZZI_GROUP =
  "https://images.pexels.com/photos/3851222/pexels-photo-3851222.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const MEMBERSHIPS = [
  {
    id: "silver",
    name: "Silver Pass",
    tagline: "A gentle monthly reset",
    features: [
      "2 × 60-min massages of your choice",
      "10% off additional sessions",
      "Priority phone booking",
      "Complimentary herbal tea on arrival",
    ],
    featured: false,
  },
  {
    id: "gold",
    name: "Gold Renewal",
    tagline: "Our most-loved service",
    features: [
      "4 × 60-min massages of your choice",
      "1 free upgrade to 90 minutes",
      "15% off add-ons & upgrades",
      "Complimentary aroma oil blending",
      "Priority weekend slots",
    ],
    featured: true,
  },
  {
    id: "platinum",
    name: "Royal Platinum Sanctum",
    tagline: "The full Belong sanctuary",
    features: [
      "4 × 90-min signature massages",
      "1 × Four Hand session included",
      "1 × Jacuzzi Spa session included",
      "20% off everything else",
      "Dedicated wellness concierge",
      "One guest pass per month",
    ],
    featured: false,
  },
];

export const REVIEWS = [
  {
    quote: "The deep tissue session undid months of desk stiffness in one evening. The room, the oil, the pace — everything is considered.",
    name: "Aarav M.",
    role: "Deep Tissue regular",
    rating: 5,
  },
  {
    quote: "Four hands felt like meditation I didn't have to work for. I've stopped recommending anything else to my colleagues.",
    name: "Priya S.",
    role: "Four Hand guest",
    rating: 5,
  },
  {
    quote: "Jacuzzi first, then a 90-minute Balinese. I floated home. Easily the most peaceful address in Suchitra.",
    name: "Rohit K.",
    role: "Gold member",
    rating: 5,
  },
  {
    quote: "The aroma therapy blend they chose for me actually helped me sleep properly for the first time in weeks.",
    name: "Sneha R.",
    role: "Aroma Therapy guest",
    rating: 5,
  },
  {
    quote: "Clean suites, fresh linen, therapists who check your pressure without being asked twice. Rare professionalism.",
    name: "Vikram T.",
    role: "Full Body Massage regular",
    rating: 5,
  },
  {
    quote: "Booked on WhatsApp at 6, on the table by 7. The Thai massage left me standing straighter than I have in years.",
    name: "Ananya D.",
    role: "Thai Massage guest",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "How do I book a session?",
    a: "Use the booking form on our Contact page — pick a service, duration and date, and it opens WhatsApp with your request ready to send. Or simply call 098666 34473.",
  },
  {
    q: "What durations are available?",
    a: "Most massages are offered in 45, 60, 90 and 120-minute sessions. Four Hand Massage and Jacuzzi Spa begin at 60 minutes (60, 90 and 120 minutes).",
  },
  {
    q: "Do I need to prepare anything?",
    a: "Just arrive 10 minutes early and avoid a heavy meal right before your session. Fresh linen, towels and everything else are provided.",
  },
  {
    q: "Are the massage oils safe for sensitive skin?",
    a: "Yes. We use premium cold-pressed and essential-oil blends. Tell your therapist about any allergy and we will adjust the blend or use a neutral oil.",
  },
  {
    q: "Where exactly are you located?",
    a: "1st Floor, Plot no - 121, Road - 3, Quthbullapur Main Rd, opp. Barath Petrol Pump, Suchitra, Hyderabad 500055. Free parking guidance is available on call.",
  },
];
